import { Add, Remove } from "@mui/icons-material";
import { Button, ButtonGroup, Chip, useTheme } from "@mui/material";
import { useState } from "react";
import { Tool, User } from "../../../app/backendTypes";
import BoardingDialog from "./BoardingDialog";

function BoardingAction(props: {
  disabled: boolean;
  onboarded: boolean;
  tool: Tool;
  user: User;
  callback: () => void;
}) {
  const { disabled, onboarded, tool, user, callback } = props;

  const label = onboarded ? "Allowed" : "Blocked";
  const color = onboarded ? "success" : "error";
  const actionColor = onboarded ? "error" : "success";
  const actionIcon = onboarded ? <Remove /> : <Add />;

  const [open, setOpen] = useState(false);

  const theme = useTheme();

  return (
    <>
      <ButtonGroup size="small">
        <Chip
          variant="outlined"
          label={label}
          color={color}
          sx={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 0,
          }}
        />
        <Button
          sx={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20,
            borderLeftColor: theme.palette.divider,
          }}
          onClick={() => setOpen(true)}
          color={actionColor}
          disabled={disabled}
        >
          {actionIcon}
        </Button>
      </ButtonGroup>

      <BoardingDialog
        onboarded={onboarded}
        open={open}
        setOpen={setOpen}
        callback={callback}
        tool={tool}
        user={user}
      />
    </>
  );
}

export default BoardingAction;
